import React, { useEffect, useMemo } from "react";
import useObservedExpression from "../../Hooks/useObservedExpression";
import { RepeatContainerModel } from "../../Models/RepeatContainerModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";

const RepeatContainerComponent: React.FC<IComponentProps<RepeatContainerModel>> = ({ component, context }) => {
  const [items, itemsPending] = useObservedExpression<any[]>(component.Items, context, "RepeatContainerComponent", (value, error) => {
    if (error || value === undefined || value === null) {
      return [];
    }

    if (!Array.isArray(value)) {
      console.error("Items expression did not return an array:", value);
      throw new Error("Items expression did not return an array: " + value);
    }
    return value;
  });

  useEffect(() => {
    console.log(`[RepeatContainerComponent] ${component.Id}: Items updated:`, items);
  }, [items]);

  const itemVariableScope = useMemo(
    () =>
      items?.map((item, index) => {
        const itemKey = item[component.ItemKeyField] ?? index;
        const itemContext = context.CreateChild();
        itemContext.VariableScope.set("$item", item);
        return { itemKey: itemKey, itemContext: itemContext };
      }),
    [context, items]
  );

  if (itemsPending) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {itemVariableScope?.map(({ itemKey, itemContext }) => {
        return (
          <React.Fragment key={itemKey}>
            {component.Children.map((child) => (
              <ComponentFactory parent={component} key={child.Id} component={child} context={itemContext} />
            ))}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default RepeatContainerComponent;
